var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { LabModel } from './model/lab-model';
import { LabApi } from './repository/lab-api';
import _ from 'lodash';
import { LABS_KEY_NAME_MAPPING, LABS_NAME_KEY_MAPPING } from './constants';
import { FeatureConfig } from '../feature-config/types/feature-config.interface';
let LabService = class LabService {
    constructor(_labModal, _labApi, _featureConfigService) {
        this._labModal = _labModal;
        this._labApi = _labApi;
        this._featureConfigService = _featureConfigService;
    }
    get labModal() {
        return this._labModal;
    }
    initLabModal() {
        if (!this._featureConfigService.enableLabFeature)
            return Promise.resolve();
        return this.getLabAnchorMap().then((labAnchorMap) => {
            this._labModal.updateLabAnchorMap(labAnchorMap);
        });
    }
    getLabAnchorMap() {
        const anchors = _.values(LABS_NAME_KEY_MAPPING);
        return this._labApi.getBatchUsedByAnchorApi(anchors).then((data) => {
            const anchorMap = {};
            _.forEach(data, (item) => {
                _.set(anchorMap, LABS_KEY_NAME_MAPPING[item.anchor], item);
            });
            return anchorMap;
        });
    }
    getAnchorItem(labName) {
        return this._labModal.getAnchorItem(labName);
    }
};
LabService = __decorate([
    injectable(),
    __param(0, inject(LabModel)),
    __param(1, inject(LabApi)),
    __param(2, inject(FeatureConfig)),
    __metadata("design:paramtypes", [typeof (_a = typeof LabModel !== "undefined" && LabModel) === "function" ? _a : Object, typeof (_b = typeof LabApi !== "undefined" && LabApi) === "function" ? _b : Object, typeof (_c = typeof FeatureConfig !== "undefined" && FeatureConfig) === "function" ? _c : Object])
], LabService);
export { LabService };
